import React from 'react'

function Header() {
  return (
    <div>
        <p className='bg-white items-center flex text-xs font-semibold uppercase text-pink-600 bg-pink-200 uppercase'>
      <img className='logo' src="https://cdn.leonardo.ai/users/95252ff4-e322-44f2-9acf-a23ac5697555/generations/cc57a78f-d106-4d4d-9510-6648525d27c6/variations/Default_pen_logo_simple_solid_flat_color_background_one_objec_0_cc57a78f-d106-4d4d-9510-6648525d27c6_0.png" />
      Stylus</p>
    </div>
  )
}

export default Header